export default __webpack_public_path__ + "static/media/ayodele_samuel_adebayo.cb6eabb6.jpg";